import { useState } from "react";
import {
  agregarAlCarrito,
  ErrorValidacionItemCarrito,
  isErrorValidacionItemCarrito,
  isExitoValidacionItemCarrito,
  NuevoItemCarritoRequest,
  QUERY_EXISTE_CARRITO,
  QUERY_LEER_CARRITO,
  useExisteCarrito,
  useLeerCarrito,
  validarInclusionACarrito,
} from "../services/carritoServicios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCarrito = () => {
  const queryClient = useQueryClient();

  const [errorValidacionInclusionCarrito, setErrorValidacionInclusionCarrito] =
    useState<ErrorValidacionItemCarrito | undefined>();

  const {
    data: existeCarrito,
    isError: existeCarritoIsError,
    isSuccess: existeCarritoIsSuccess,
  } = useExisteCarrito();

  const {
    data: carrito,
    isFetching: carritoIsFetching,
    isError: carritoIsError,
    isSuccess: carritoIsSuccess,
  } = useLeerCarrito(existeCarritoIsSuccess && existeCarrito);

  const {
    isError: agregarAlCarritoIsError,
    isLoading: agregarAlCarritoIsLoading,
    mutate: mutarAgregarAlCarrito,
    isSuccess: agregarAlCarritoIsSuccess,
  } = useMutation(agregarAlCarrito, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_LEER_CARRITO, QUERY_EXISTE_CARRITO],
      });
    },
  });

  const validarInclusion = (item: NuevoItemCarritoRequest): boolean => {
    if(existeCarritoIsSuccess && !existeCarrito){
      return true;
    }
    if (carritoIsSuccess && existeCarrito && carrito) {
      const resultadoValidacion = validarInclusionACarrito(item, carrito);
      if (isErrorValidacionItemCarrito(resultadoValidacion)) {
        setErrorValidacionInclusionCarrito(resultadoValidacion);
        return false;
      }
      if (isExitoValidacionItemCarrito(resultadoValidacion)) {
        return true;
      }
    }
    return false;
  };

  const isError = carritoIsError || existeCarritoIsError || agregarAlCarritoIsError;

  return {
    preparationOperationsIsLoading: carritoIsFetching,
    existeCarritoIsError,
    errorValidacionInclusionCarrito,
    setErrorValidacionInclusionCarrito,
    validarInclusion,
    mutarAgregarAlCarrito,
    agregarAlCarritoIsError,
    agregarAlCarritoIsLoading,
    agregarAlCarritoIsSuccess,
    isError
  };
};
